// extracted by mini-css-extract-plugin
export default {"Paragraph":"Paragraph_Paragraph__hGqAi","left":"Paragraph_left__2U8P8","right":"Paragraph_right__rOhz0","neutral":"Paragraph_neutral__h8eiP","bright":"Paragraph_bright__t9cvn"};